'use strict';

var angular = require('angular');
var PrepareItemsModalDirective = function PrepareItemsModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/prepare-items-modal.html'),
    controller: 'PrepareItemsModalController',
    link: function link(scope) {
      var modalElement = angular.element('#prepare-items-modal');
      modalElement.bind('show.bs.modal', function () {
        scope.showInput(scope.manageItems);
      });
      scope.showInput = function (type) {
        scope.showNewInput = type;
        if (type === scope.MANAGE_ITEMS_EXISTING) {
          scope.selectedItems[scope.MANAGE_ITEMS_NEW] = '';
        } else {
          scope.selectedItems[scope.MANAGE_ITEMS_EXISTING] = '';
        }
      };
      modalElement.on('hidden.bs.modal', function () {
        scope.cancelPreparedItems();
      });
      scope.hideModal = function () {
        modalElement.modal('hide');
      };
    }
  };
};
PrepareItemsModalDirective.$inject = [];
module.exports = PrepareItemsModalDirective;